// Océana Group - Mock Data
// Plateforme intégrée du producteur au rayon

export const brandAssets = {
  logo: "https://customer-assets.emergentagent.com/job_e0d36ff9-afe9-42cc-acb6-596aa3a8fe6f/artifacts/lt33l9w1_6FA12A78-938C-4DE4-9159-597D78E23F7F.png",
  hubWarehouse: "https://static.prod-images.emergentagent.com/jobs/e0d36ff9-afe9-42cc-acb6-596aa3a8fe6f/images/3ed94ea5875a459a2ea097108a45031d1717d036c5add4024d7d2f96f5d9f4dd.png",
  dialloLogo: "https://diallo-quartier.preview.emergentagent.com/brand/diallo_horizontal_white.svg"
};

export const whatsappNumber = '+2250758148075';

// Les 6 métiers d'Océana (incluant les 3 Hubs de sourcing)
export const businessLines = {
  fr: [
    {
      id: 'sourcing',
      title: 'Sourcing & Conditionnement Europe',
      tagline: 'Direct producteur, qualité contrôlée',
      description: 'Achat direct auprès des producteurs du Sud-Ouest de la France, Espagne, Italie, Portugal et Benelux. Conditionnement dans notre atelier de Boulogne-sur-Gesse : tri, calibrage, emballage, pré-refroidissement, empotage en conteneurs frigorifiques.',
      features: [
        'Achat direct producteur, sans intermédiaire',
        'Atelier de conditionnement en Haute-Garonne',
        'Agréage qualité avant chaque départ',
        'Empotage conteneurs frigorifiques'
      ],
      icon: 'Package'
    },
    {
      id: 'sourcing-africa',
      title: 'Sourcing & Conditionnement Afrique du Sud',
      tagline: 'Contre-saison, qualité identique',
      description: 'Notre hub de Stellenbosch assure le sourcing en contre-saison : achat direct auprès des producteurs sud-africains (Western Cape, Limpopo, Mpumalanga). Conditionnement selon les mêmes standards qu\'en Europe : tri, calibrage, emballage, pré-refroidissement, empotage en conteneurs frigorifiques.',
      features: [
        'Achat direct producteurs sud-africains',
        'Atelier de conditionnement à Stellenbosch',
        'Contre-saison européenne (mai-octobre)',
        'Mêmes standards qualité qu\'en Europe'
      ],
      icon: 'Package'
    },
    {
      id: 'sourcing-uae',
      title: 'Sourcing & Conditionnement Émirats',
      tagline: 'Porte d\'entrée Asie & Moyen-Orient',
      description: 'Notre hub d\'Ajman aux Émirats Arabes Unis assure le sourcing depuis l\'Asie (Inde, Pakistan, Thaïlande, Vietnam) et sert le Moyen-Orient. Conditionnement selon les mêmes standards : tri, calibrage, emballage, pré-refroidissement, empotage en conteneurs frigorifiques.',
      features: [
        'Achat direct producteurs asiatiques',
        'Atelier de conditionnement à Ajman',
        'Desserte Moyen-Orient & Afrique',
        'Importations Inde, Pakistan, Thaïlande, Vietnam'
      ],
      icon: 'Package'
    },
    {
      id: 'hub',
      title: 'Hub Froid Abidjan',
      tagline: 'La chaîne du froid jamais rompue',
      description: 'Réception des conteneurs, dédouanement, puis traitement dans notre hub d\'Abidjan : chambre froide multi-température, mûrisserie pilotée, préparation de commandes, livraison frigorifique.',
      features: [
        'Chambre froide multi-température',
        'Mûrisserie pilotée (banane, mangue, avocat, tomate)',
        'Livraison "mûri à point"',
        'Flotte frigorifique dédiée'
      ],
      icon: 'Thermometer'
    },
    {
      id: 'distribution',
      title: 'Distribution Afrique & Moyen-Orient',
      tagline: 'Régularité toute l\'année',
      description: 'Approvisionnement des grandes surfaces, hôtels-restaurants et grossistes avec une promesse de régularité, ponctualité et traçabilité complète.',
      features: [
        'Grandes surfaces partenaires',
        'Hôtellerie & restauration premium',
        'Grossistes et distributeurs',
        'Traçabilité complète du producteur au rayon'
      ],
      icon: 'Truck'
    },
    {
      id: 'diallo',
      title: 'Réseau Diallo',
      tagline: 'Le quartier me connaît',
      description: 'Partenariat stratégique avec Diallo, le premier réseau moderne de commerces de proximité d\'Afrique. Distribution de nos fruits et légumes frais dans les boutiques de quartier transformées en franchises Diallo.',
      features: [
        '10 boutiques pilotes à Abidjan',
        'Approvisionnement quotidien en fruits & légumes',
        'Proximité : à deux pas de chez vous',
        'Prix accessibles pour tous'
      ],
      icon: 'Users',
      partnerLogo: 'https://diallo-quartier.preview.emergentagent.com/brand/diallo_horizontal_white.svg',
      partnerUrl: 'https://diallo-quartier.preview.emergentagent.com/'
    }
  ],
  en: [
    {
      id: 'sourcing',
      title: 'European Sourcing & Packaging',
      tagline: 'Direct from producers, quality controlled',
      description: 'Direct purchasing from producers in South-West France, Spain, Italy, Portugal and Benelux. Packaging in our Boulogne-sur-Gesse facility: sorting, grading, packaging, pre-cooling, loading into refrigerated containers.',
      features: [
        'Direct producer purchasing, no intermediaries',
        'Packaging facility in Haute-Garonne, France',
        'Quality control before each shipment',
        'Refrigerated container loading'
      ],
      icon: 'Package'
    },
    {
      id: 'sourcing-africa',
      title: 'South Africa Sourcing & Packaging',
      tagline: 'Counter-season, same quality',
      description: 'Our Stellenbosch hub handles counter-season sourcing: direct purchasing from South African producers (Western Cape, Limpopo, Mpumalanga). Packaging following the same European standards: sorting, grading, packaging, pre-cooling, loading into refrigerated containers.',
      features: [
        'Direct South African producer purchasing',
        'Packaging facility in Stellenbosch',
        'European off-season (May-October)',
        'Same quality standards as Europe'
      ],
      icon: 'Package'
    },
    {
      id: 'sourcing-uae',
      title: 'UAE Sourcing & Packaging',
      tagline: 'Gateway to Asia & Middle East',
      description: 'Our Ajman hub in the United Arab Emirates handles sourcing from Asia (India, Pakistan, Thailand, Vietnam) and serves the Middle East. Packaging following the same standards: sorting, grading, packaging, pre-cooling, loading into refrigerated containers.',
      features: [
        'Direct Asian producer purchasing',
        'Packaging facility in Ajman',
        'Middle East & Africa distribution',
        'Imports from India, Pakistan, Thailand, Vietnam'
      ],
      icon: 'Package'
    },
    {
      id: 'hub',
      title: 'Abidjan Cold Hub',
      tagline: 'Unbroken cold chain',
      description: 'Container reception, customs clearance, then processing in our Abidjan hub: multi-temperature cold storage, controlled ripening rooms, order preparation, refrigerated delivery.',
      features: [
        'Multi-temperature cold storage',
        'Controlled ripening (banana, mango, avocado, tomato)',
        '"Ripened to perfection" delivery',
        'Dedicated refrigerated fleet'
      ],
      icon: 'Thermometer'
    },
    {
      id: 'distribution',
      title: 'Distribution Africa & Middle East',
      tagline: 'Year-round reliability',
      description: 'Supplying supermarkets, hotels-restaurants and wholesalers with a promise of reliability, punctuality and complete traceability.',
      features: [
        'Partner supermarkets',
        'Premium hospitality & restaurants',
        'Wholesalers and distributors',
        'Complete traceability from producer to shelf'
      ],
      icon: 'Truck'
    },
    {
      id: 'diallo',
      title: 'Diallo Network',
      tagline: 'The neighborhood knows me',
      description: 'Strategic partnership with Diallo, Africa\'s first modern neighborhood convenience store network. Distribution of our fresh fruits and vegetables in neighborhood shops transformed into Diallo franchises.',
      features: [
        '10 pilot stores in Abidjan',
        'Daily fresh fruit & vegetable supply',
        'Proximity: just steps from your home',
        'Accessible prices for everyone'
      ],
      icon: 'Users',
      partnerLogo: 'https://diallo-quartier.preview.emergentagent.com/brand/diallo_horizontal_white.svg',
      partnerUrl: 'https://diallo-quartier.preview.emergentagent.com/'
    }
  ]
};

// Les 5 piliers de marque
export const brandPillars = {
  fr: [
    {
      id: 'direct',
      title: 'Du producteur au rayon',
      description: 'Moins d\'intermédiaires, plus de fraîcheur, prix justes des deux côtés.',
      icon: 'ArrowRight'
    },
    {
      id: 'cold',
      title: 'Chaîne du froid intacte',
      description: 'Du verger au magasin, sans jamais rompre la chaîne du froid.',
      icon: 'Thermometer'
    },
    {
      id: 'ripened',
      title: 'Mûri à point',
      description: 'Mûrisserie pilotée, un savoir-faire rare sur le marché.',
      icon: 'Clock'
    },
    {
      id: 'seasons',
      title: 'Toutes les saisons',
      description: 'Europe, Maghreb, Afrique australe — le bon produit au bon moment.',
      icon: 'Calendar'
    },
    {
      id: 'local',
      title: 'Local d\'abord',
      description: 'Oignon de la sous-région, banane régionale, production ivoirienne en construction.',
      icon: 'MapPin'
    }
  ],
  en: [
    {
      id: 'direct',
      title: 'Producer to shelf',
      description: 'Fewer intermediaries, more freshness, fair prices on both sides.',
      icon: 'ArrowRight'
    },
    {
      id: 'cold',
      title: 'Unbroken cold chain',
      description: 'From orchards to stores, without ever breaking the cold chain.',
      icon: 'Thermometer'
    },
    {
      id: 'ripened',
      title: 'Ripened to perfection',
      description: 'Controlled ripening rooms, a rare expertise in the market.',
      icon: 'Clock'
    },
    {
      id: 'seasons',
      title: 'All seasons',
      description: 'Europe, Maghreb, Southern Africa — the right product at the right time.',
      icon: 'Calendar'
    },
    {
      id: 'local',
      title: 'Local first',
      description: 'Regional onions, local bananas, Ivorian production in development.',
      icon: 'MapPin'
    }
  ]
};

// Produits par saison - Catalogue complet avec origines et périodes détaillées
export const productSeasons = {
  fr: {
    title: 'Produits & Saisons',
    subtitle: 'Le bon produit, au bon moment, de la bonne origine',
    categories: [
      {
        name: 'Fruits',
        families: [
          {
            name: 'Pommes',
            varieties: ['Golden', 'Gala', 'Royal Gala', 'Granny Smith', 'Pink Lady', 'Fuji'],
            season: 'Toute l\'année',
            origins: [
              { country: 'France', period: 'Sept - Mai' },
              { country: 'Italie', period: 'Sept - Mai' },
              { country: 'Afrique du Sud', period: 'Mai - Sept' },
              { country: 'Chili', period: 'Avr - Août' }
            ],
            icon: '🍎'
          },
          {
            name: 'Poires',
            varieties: ['Conférence', 'Williams', 'Comice', 'Abate'],
            season: 'Toute l\'année',
            origins: [
              { country: 'France', period: 'Août - Mars' },
              { country: 'Portugal', period: 'Août - Fév' },
              { country: 'Afrique du Sud', period: 'Mars - Août' },
              { country: 'Argentine', period: 'Fév - Juil' }
            ],
            icon: '🍐'
          },
          {
            name: 'Oranges',
            varieties: ['Navel', 'Valencia', 'Sanguine', 'Salustiana'],
            season: 'Toute l\'année',
            origins: [
              { country: 'Espagne', period: 'Nov - Juin' },
              { country: 'Maroc', period: 'Déc - Mai' },
              { country: 'Afrique du Sud', period: 'Juin - Oct' },
              { country: 'Égypte', period: 'Fév - Juil' }
            ],
            icon: '🍊'
          },
          {
            name: 'Clémentines & Mandarines',
            varieties: ['Clémentine', 'Mandarine', 'Clemenvilla', 'Nadorcott'],
            season: 'Oct - Fév',
            origins: [
              { country: 'Espagne', period: 'Oct - Fév' },
              { country: 'Maroc', period: 'Nov - Fév' }
            ],
            icon: '🍊'
          },
          {
            name: 'Citrons & Limes',
            varieties: ['Citron jaune', 'Citron vert', 'Lime'],
            season: 'Toute l\'année',
            origins: [
              { country: 'Espagne', period: 'Oct - Avr' },
              { country: 'Italie', period: 'Nov - Mai' },
              { country: 'Afrique du Sud', period: 'Mai - Sept' },
              { country: 'Brésil', period: 'Toute l\'année' }
            ],
            icon: '🍋'
          },
          {
            name: 'Pamplemousses',
            varieties: ['Rose', 'Blanc', 'Pomelo'],
            season: 'Toute l\'année',
            origins: [
              { country: 'Espagne', period: 'Oct - Avr' },
              { country: 'Israël', period: 'Nov - Mai' },
              { country: 'Afrique du Sud', period: 'Mai - Oct' }
            ],
            icon: '🍊'
          },
          {
            name: 'Raisin de table',
            varieties: ['Thompson', 'Red Globe', 'Crimson', 'Italia', 'Muscat'],
            season: 'Toute l\'année',
            origins: [
              { country: 'France', period: 'Août - Oct' },
              { country: 'Espagne', period: 'Juil - Nov' },
              { country: 'Italie', period: 'Juil - Déc' },
              { country: 'Afrique du Sud', period: 'Janv - Mai' },
              { country: 'Pérou', period: 'Nov - Mars' },
              { country: 'Inde', period: 'Fév - Mai' }
            ],
            icon: '🍇'
          },
          {
            name: 'Banane',
            varieties: ['Cavendish', 'Plantain', 'Frécinette'],
            season: 'Toute l\'année',
            origins: [
              { country: 'Côte d\'Ivoire', period: 'Toute l\'année' },
              { country: 'Cameroun', period: 'Toute l\'année' },
              { country: 'Équateur', period: 'Toute l\'année' }
            ],
            icon: '🍌',
            ripened: true
          },
          {
            name: 'Ananas',
            varieties: ['Sweet', 'Victoria', 'Cayenne'],
            season: 'Toute l\'année',
            origins: [
              { country: 'Côte d\'Ivoire', period: 'Toute l\'année' },
              { country: 'Costa Rica', period: 'Toute l\'année' },
              { country: 'Ghana', period: 'Toute l\'année' }
            ],
            icon: '🍍'
          },
          {
            name: 'Mangue',
            varieties: ['Kent', 'Keitt', 'Tommy Atkins', 'Amélie', 'Alphonso', 'Sindhri'],
            season: 'Toute l\'année',
            origins: [
              { country: 'Côte d\'Ivoire', period: 'Mars - Juil' },
              { country: 'Mali', period: 'Avr - Juil' },
              { country: 'Sénégal', period: 'Mai - Août' },
              { country: 'Pérou', period: 'Déc - Mars' },
              { country: 'Brésil', period: 'Sept - Déc' },
              { country: 'Inde', period: 'Avr - Juil' },
              { country: 'Pakistan', period: 'Mai - Août' },
              { country: 'Thaïlande', period: 'Mars - Juin' }
            ],
            icon: '🥭',
            ripened: true
          },
          {
            name: 'Avocat',
            varieties: ['Hass', 'Fuerte', 'Bacon'],
            season: 'Toute l\'année',
            origins: [
              { country: 'Pérou', period: 'Avr - Sept' },
              { country: 'Kenya', period: 'Mars - Sept' },
              { country: 'Espagne', period: 'Oct - Fév' },
              { country: 'Mexique', period: 'Oct - Mars' },
              { country: 'Chili', period: 'Sept - Fév' }
            ],
            icon: '🥑',
            ripened: true
          },
          {
            name: 'Papaye',
            varieties: ['Solo', 'Formosa'],
            season: 'Toute l\'année',
            origins: [
              { country: 'Côte d\'Ivoire', period: 'Toute l\'année' },
              { country: 'Brésil', period: 'Toute l\'année' },
              { country: 'Ghana', period: 'Toute l\'année' }
            ],
            icon: '🥭'
          },
          {
            name: 'Kiwi',
            varieties: ['Hayward', 'Gold', 'Baby kiwi'],
            season: 'Toute l\'année',
            origins: [
              { country: 'France', period: 'Nov - Mai' },
              { country: 'Italie', period: 'Nov - Mai' },
              { country: 'Nouvelle-Zélande', period: 'Mai - Nov' },
              { country: 'Chili', period: 'Avr - Sept' }
            ],
            icon: '🥝'
          },
          {
            name: 'Pêches & Nectarines',
            varieties: ['Pêche jaune', 'Pêche blanche', 'Nectarine', 'Brugnon'],
            season: 'Toute l\'année',
            origins: [
              { country: 'France', period: 'Juin - Sept' },
              { country: 'Espagne', period: 'Mai - Sept' },
              { country: 'Afrique du Sud', period: 'Nov - Mars' },
              { country: 'Chili', period: 'Déc - Avr' }
            ],
            icon: '🍑'
          },
          {
            name: 'Abricots',
            varieties: ['Bergeron', 'Orangered', 'Rouge du Roussillon'],
            season: 'Mai - Août',
            origins: [
              { country: 'France', period: 'Juin - Août' },
              { country: 'Espagne', period: 'Mai - Juil' },
              { country: 'Italie', period: 'Juin - Juil' }
            ],
            icon: '🍑'
          },
          {
            name: 'Prunes',
            varieties: ['Reine-Claude', 'Mirabelle', 'Quetsche'],
            season: 'Juil - Sept',
            origins: [
              { country: 'France', period: 'Juil - Sept' },
              { country: 'Espagne', period: 'Juil - Sept' }
            ],
            icon: '🍑'
          },
          {
            name: 'Cerises',
            varieties: ['Burlat', 'Summit', 'Sweetheart'],
            season: 'Mai - Juil',
            origins: [
              { country: 'France', period: 'Mai - Juil' },
              { country: 'Espagne', period: 'Avr - Juin' },
              { country: 'Italie', period: 'Mai - Juil' }
            ],
            icon: '🍒'
          },
          {
            name: 'Fraises',
            varieties: ['Gariguette', 'Ciflorette', 'Charlotte'],
            season: 'Toute l\'année',
            origins: [
              { country: 'France', period: 'Avr - Oct' },
              { country: 'Espagne', period: 'Janv - Mai' },
              { country: 'Maroc', period: 'Déc - Avr' }
            ],
            icon: '🍓'
          },
          {
            name: 'Framboises & Fruits rouges',
            varieties: ['Framboise', 'Myrtille', 'Mûre', 'Groseille'],
            season: 'Mai - Oct',
            origins: [
              { country: 'France', period: 'Juin - Sept' },
              { country: 'Espagne', period: 'Mai - Juil' },
              { country: 'Portugal', period: 'Avr - Oct' }
            ],
            icon: '🫐'
          },
          {
            name: 'Melon',
            varieties: ['Charentais', 'Cantaloup', 'Galia', 'Piel de Sapo'],
            season: 'Toute l\'année',
            origins: [
              { country: 'France', period: 'Juin - Sept' },
              { country: 'Espagne', period: 'Mai - Oct' },
              { country: 'Maroc', period: 'Avr - Juin' },
              { country: 'Sénégal', period: 'Nov - Mai' },
              { country: 'Brésil', period: 'Oct - Mars' }
            ],
            icon: '🍈'
          },
          {
            name: 'Pastèque',
            varieties: ['Sugar Baby', 'Crimson Sweet', 'Sans pépins'],
            season: 'Toute l\'année',
            origins: [
              { country: 'Espagne', period: 'Mai - Sept' },
              { country: 'Maroc', period: 'Avr - Juil' },
              { country: 'Sénégal', period: 'Déc - Avr' },
              { country: 'Brésil', period: 'Oct - Mars' }
            ],
            icon: '🍉'
          },
          {
            name: 'Noix de coco',
            varieties: ['Coco frais', 'Coco sec', 'Eau de coco'],
            season: 'Toute l\'année',
            origins: [
              { country: 'Côte d\'Ivoire', period: 'Toute l\'année' },
              { country: 'Sri Lanka', period: 'Toute l\'année' },
              { country: 'Thaïlande', period: 'Toute l\'année' },
              { country: 'Vietnam', period: 'Toute l\'année' },
              { country: 'Inde', period: 'Toute l\'année' }
            ],
            icon: '🥥'
          }
        ]
      },
      {
        name: 'Légumes',
        families: [
          {
            name: 'Tomates',
            varieties: ['Ronde', 'Grappe', 'Cerise', 'Cœur de bœuf', 'Roma'],
            season: 'Toute l\'année',
            origins: [
              { country: 'Espagne', period: 'Oct - Juin' },
              { country: 'Maroc', period: 'Nov - Mai' },
              { country: 'Pays-Bas', period: 'Avr - Nov' },
              { country: 'France', period: 'Juin - Oct' }
            ],
            icon: '🍅',
            ripened: true
          },
          {
            name: 'Poivrons',
            varieties: ['Rouge', 'Jaune', 'Vert', 'Orange'],
            season: 'Toute l\'année',
            origins: [
              { country: 'Espagne', period: 'Oct - Juin' },
              { country: 'Maroc', period: 'Nov - Mai' },
              { country: 'Pays-Bas', period: 'Avr - Nov' }
            ],
            icon: '🫑'
          },
          {
            name: 'Concombres',
            varieties: ['Long', 'Noa', 'Mini'],
            season: 'Toute l\'année',
            origins: [
              { country: 'Espagne', period: 'Sept - Juin' },
              { country: 'Pays-Bas', period: 'Avr - Oct' }
            ],
            icon: '🥒'
          },
          {
            name: 'Courgettes',
            varieties: ['Verte', 'Jaune', 'Ronde'],
            season: 'Toute l\'année',
            origins: [
              { country: 'Espagne', period: 'Sept - Juin' },
              { country: 'Maroc', period: 'Oct - Avr' },
              { country: 'France', period: 'Mai - Oct' }
            ],
            icon: '🥒'
          },
          {
            name: 'Aubergines',
            varieties: ['Longue', 'Ronde', 'Graffiti'],
            season: 'Toute l\'année',
            origins: [
              { country: 'Espagne', period: 'Sept - Juin' },
              { country: 'Pays-Bas', period: 'Avr - Oct' }
            ],
            icon: '🍆'
          },
          {
            name: 'Oignons',
            varieties: ['Jaune', 'Rouge', 'Blanc', 'Échalote'],
            season: 'Toute l\'année',
            origins: [
              { country: 'France', period: 'Août - Avr' },
              { country: 'Pays-Bas', period: 'Juil - Avr' },
              { country: 'Espagne', period: 'Avr - Sept' },
              { country: 'Sénégal', period: 'Déc - Avr' },
              { country: 'Niger', period: 'Nov - Mars' },
              { country: 'Burkina Faso', period: 'Nov - Mars' },
              { country: 'Inde', period: 'Toute l\'année' },
              { country: 'Pakistan', period: 'Nov - Avr' }
            ],
            icon: '🧅'
          },
          {
            name: 'Ail',
            varieties: ['Blanc', 'Rose', 'Violet'],
            season: 'Toute l\'année',
            origins: [
              { country: 'France', period: 'Juil - Mars' },
              { country: 'Espagne', period: 'Juin - Mars' },
              { country: 'Argentine', period: 'Fév - Juil' }
            ],
            icon: '🧄'
          },
          {
            name: 'Pommes de terre',
            varieties: ['Charlotte', 'Bintje', 'Ratte', 'Grenaille', 'Agata'],
            season: 'Toute l\'année',
            origins: [
              { country: 'France', period: 'Juin - Mars' },
              { country: 'Pays-Bas', period: 'Juil - Avr' },
              { country: 'Allemagne', period: 'Août - Mai' },
              { country: 'Niger', period: 'Nov - Fév' },
              { country: 'Burkina Faso', period: 'Nov - Fév' }
            ],
            icon: '🥔'
          },
          {
            name: 'Carottes',
            varieties: ['Nantaise', 'Botte', 'Mini', 'Couleurs'],
            season: 'Toute l\'année',
            origins: [
              { country: 'France', period: 'Juin - Avr' },
              { country: 'Pays-Bas', period: 'Juil - Mai' },
              { country: 'Espagne', period: 'Nov - Mai' }
            ],
            icon: '🥕'
          },
          {
            name: 'Poireaux',
            varieties: ['Gros', 'Mini'],
            season: 'Sept - Avr',
            origins: [
              { country: 'France', period: 'Sept - Avr' },
              { country: 'Belgique', period: 'Oct - Mars' }
            ],
            icon: '🥬'
          },
          {
            name: 'Choux',
            varieties: ['Blanc', 'Rouge', 'Vert', 'Fleur', 'Brocoli', 'Romanesco', 'Bruxelles'],
            season: 'Toute l\'année',
            origins: [
              { country: 'France', period: 'Août - Avr' },
              { country: 'Espagne', period: 'Oct - Mai' },
              { country: 'Pays-Bas', period: 'Juin - Nov' }
            ],
            icon: '🥦'
          },
          {
            name: 'Salades',
            varieties: ['Laitue', 'Batavia', 'Feuille de chêne', 'Iceberg', 'Romaine', 'Mâche', 'Roquette'],
            season: 'Toute l\'année',
            origins: [
              { country: 'France', period: 'Avr - Nov' },
              { country: 'Espagne', period: 'Oct - Mai' }
            ],
            icon: '🥬'
          },
          {
            name: 'Épinards',
            varieties: ['Feuille', 'Pousse'],
            season: 'Toute l\'année',
            origins: [
              { country: 'France', period: 'Mars - Nov' },
              { country: 'Espagne', period: 'Oct - Avr' }
            ],
            icon: '🥬'
          },
          {
            name: 'Haricots verts',
            varieties: ['Extra-fins', 'Fins', 'Plats'],
            season: 'Toute l\'année',
            origins: [
              { country: 'Kenya', period: 'Toute l\'année' },
              { country: 'Maroc', period: 'Oct - Mai' },
              { country: 'Sénégal', period: 'Nov - Avr' }
            ],
            icon: '🫛'
          },
          {
            name: 'Petits pois',
            varieties: ['Frais', 'Mange-tout'],
            season: 'Mars - Juil',
            origins: [
              { country: 'France', period: 'Mai - Juil' },
              { country: 'Espagne', period: 'Mars - Juin' }
            ],
            icon: '🫛'
          },
          {
            name: 'Asperges',
            varieties: ['Blanche', 'Verte', 'Violette'],
            season: 'Toute l\'année',
            origins: [
              { country: 'France', period: 'Avr - Juin' },
              { country: 'Espagne', period: 'Fév - Mai' },
              { country: 'Pérou', period: 'Sept - Déc' }
            ],
            icon: '🥬'
          },
          {
            name: 'Artichauts',
            varieties: ['Camus', 'Violet', 'Poivrade'],
            season: 'Mars - Nov',
            origins: [
              { country: 'France', period: 'Mai - Nov' },
              { country: 'Espagne', period: 'Mars - Juin' },
              { country: 'Italie', period: 'Mars - Mai' }
            ],
            icon: '🥬'
          },
          {
            name: 'Champignons',
            varieties: ['Paris', 'Shiitake', 'Pleurote', 'Portobello'],
            season: 'Toute l\'année',
            origins: [
              { country: 'France', period: 'Toute l\'année' },
              { country: 'Pays-Bas', period: 'Toute l\'année' },
              { country: 'Pologne', period: 'Toute l\'année' }
            ],
            icon: '🍄'
          },
          {
            name: 'Herbes aromatiques',
            varieties: ['Persil', 'Coriandre', 'Basilic', 'Menthe', 'Ciboulette', 'Thym', 'Romarin'],
            season: 'Toute l\'année',
            origins: [
              { country: 'France', period: 'Mai - Oct' },
              { country: 'Maroc', period: 'Toute l\'année' },
              { country: 'Israël', period: 'Toute l\'année' },
              { country: 'Thaïlande', period: 'Toute l\'année' },
              { country: 'Vietnam', period: 'Toute l\'année' }
            ],
            icon: '🌿'
          },
          {
            name: 'Gingembre & Curcuma',
            varieties: ['Gingembre frais', 'Curcuma frais'],
            season: 'Toute l\'année',
            origins: [
              { country: 'Pérou', period: 'Toute l\'année' },
              { country: 'Chine', period: 'Toute l\'année' },
              { country: 'Brésil', period: 'Toute l\'année' },
              { country: 'Inde', period: 'Toute l\'année' },
              { country: 'Thaïlande', period: 'Toute l\'année' },
              { country: 'Vietnam', period: 'Toute l\'année' }
            ],
            icon: '🫚'
          },
          {
            name: 'Piments',
            varieties: ['Jalapeño', 'Habanero', 'Oiseau', 'Doux'],
            season: 'Toute l\'année',
            origins: [
              { country: 'Espagne', period: 'Avr - Nov' },
              { country: 'Maroc', period: 'Sept - Mai' },
              { country: 'Pays-Bas', period: 'Avr - Oct' }
            ],
            icon: '🌶️'
          }
        ]
      }
    ]
  },
  en: {
    title: 'Products & Seasons',
    subtitle: 'The right product, at the right time, from the right origin',
    categories: [
      {
        name: 'Fruits',
        families: [
          {
            name: 'Apples',
            varieties: ['Golden', 'Gala', 'Royal Gala', 'Granny Smith', 'Pink Lady', 'Fuji'],
            season: 'Year-round',
            origins: [
              { country: 'France', period: 'Sep - May' },
              { country: 'Italy', period: 'Sep - May' },
              { country: 'South Africa', period: 'May - Sep' },
              { country: 'Chile', period: 'Apr - Aug' }
            ],
            icon: '🍎'
          },
          {
            name: 'Pears',
            varieties: ['Conference', 'Williams', 'Comice', 'Abate'],
            season: 'Year-round',
            origins: [
              { country: 'France', period: 'Aug - Mar' },
              { country: 'Portugal', period: 'Aug - Feb' },
              { country: 'South Africa', period: 'Mar - Aug' },
              { country: 'Argentina', period: 'Feb - Jul' }
            ],
            icon: '🍐'
          },
          {
            name: 'Oranges',
            varieties: ['Navel', 'Valencia', 'Blood Orange', 'Salustiana'],
            season: 'Year-round',
            origins: [
              { country: 'Spain', period: 'Nov - Jun' },
              { country: 'Morocco', period: 'Dec - May' },
              { country: 'South Africa', period: 'Jun - Oct' },
              { country: 'Egypt', period: 'Feb - Jul' }
            ],
            icon: '🍊'
          },
          {
            name: 'Clementines & Mandarins',
            varieties: ['Clementine', 'Mandarin', 'Clemenvilla', 'Nadorcott'],
            season: 'Oct - Feb',
            origins: [
              { country: 'Spain', period: 'Oct - Feb' },
              { country: 'Morocco', period: 'Nov - Feb' }
            ],
            icon: '🍊'
          },
          {
            name: 'Lemons & Limes',
            varieties: ['Yellow lemon', 'Green lemon', 'Lime'],
            season: 'Year-round',
            origins: [
              { country: 'Spain', period: 'Oct - Apr' },
              { country: 'Italy', period: 'Nov - May' },
              { country: 'South Africa', period: 'May - Sep' },
              { country: 'Brazil', period: 'Year-round' }
            ],
            icon: '🍋'
          },
          {
            name: 'Grapefruits',
            varieties: ['Pink', 'White', 'Pomelo'],
            season: 'Year-round',
            origins: [
              { country: 'Spain', period: 'Oct - Apr' },
              { country: 'Israel', period: 'Nov - May' },
              { country: 'South Africa', period: 'May - Oct' }
            ],
            icon: '🍊'
          },
          {
            name: 'Table grapes',
            varieties: ['Thompson', 'Red Globe', 'Crimson', 'Italia', 'Muscat'],
            season: 'Year-round',
            origins: [
              { country: 'France', period: 'Aug - Oct' },
              { country: 'Spain', period: 'Jul - Nov' },
              { country: 'Italy', period: 'Jul - Dec' },
              { country: 'South Africa', period: 'Jan - May' },
              { country: 'Peru', period: 'Nov - Mar' },
              { country: 'India', period: 'Feb - May' }
            ],
            icon: '🍇'
          },
          {
            name: 'Bananas',
            varieties: ['Cavendish', 'Plantain', 'Baby banana'],
            season: 'Year-round',
            origins: [
              { country: 'Côte d\'Ivoire', period: 'Year-round' },
              { country: 'Cameroon', period: 'Year-round' },
              { country: 'Ecuador', period: 'Year-round' }
            ],
            icon: '🍌',
            ripened: true
          },
          {
            name: 'Pineapples',
            varieties: ['Sweet', 'Victoria', 'Cayenne', 'MD2'],
            season: 'Year-round',
            origins: [
              { country: 'Côte d\'Ivoire', period: 'Year-round' },
              { country: 'Costa Rica', period: 'Year-round' },
              { country: 'Ghana', period: 'Year-round' },
              { country: 'Thailand', period: 'Year-round' },
              { country: 'Vietnam', period: 'Year-round' }
            ],
            icon: '🍍'
          },
          {
            name: 'Mangoes',
            varieties: ['Kent', 'Keitt', 'Tommy Atkins', 'Amélie', 'Alphonso', 'Sindhri'],
            season: 'Year-round',
            origins: [
              { country: 'Côte d\'Ivoire', period: 'Mar - Jul' },
              { country: 'Mali', period: 'Apr - Jul' },
              { country: 'Senegal', period: 'May - Aug' },
              { country: 'Peru', period: 'Dec - Mar' },
              { country: 'Brazil', period: 'Sep - Dec' },
              { country: 'India', period: 'Apr - Jul' },
              { country: 'Pakistan', period: 'May - Aug' },
              { country: 'Thailand', period: 'Mar - Jun' }
            ],
            icon: '🥭',
            ripened: true
          },
          {
            name: 'Avocados',
            varieties: ['Hass', 'Fuerte', 'Bacon'],
            season: 'Year-round',
            origins: [
              { country: 'Peru', period: 'Apr - Sep' },
              { country: 'Kenya', period: 'Mar - Sep' },
              { country: 'Spain', period: 'Oct - Feb' },
              { country: 'Mexico', period: 'Oct - Mar' },
              { country: 'Chile', period: 'Sep - Feb' }
            ],
            icon: '🥑',
            ripened: true
          },
          {
            name: 'Papayas',
            varieties: ['Solo', 'Formosa'],
            season: 'Year-round',
            origins: [
              { country: 'Côte d\'Ivoire', period: 'Year-round' },
              { country: 'Brazil', period: 'Year-round' },
              { country: 'Ghana', period: 'Year-round' }
            ],
            icon: '🥭'
          },
          {
            name: 'Kiwis',
            varieties: ['Hayward', 'Gold', 'Baby kiwi'],
            season: 'Year-round',
            origins: [
              { country: 'France', period: 'Nov - May' },
              { country: 'Italy', period: 'Nov - May' },
              { country: 'New Zealand', period: 'May - Nov' },
              { country: 'Chile', period: 'Apr - Sep' }
            ],
            icon: '🥝'
          },
          {
            name: 'Peaches & Nectarines',
            varieties: ['Yellow peach', 'White peach', 'Nectarine'],
            season: 'Year-round',
            origins: [
              { country: 'France', period: 'Jun - Sep' },
              { country: 'Spain', period: 'May - Sep' },
              { country: 'South Africa', period: 'Nov - Mar' },
              { country: 'Chile', period: 'Dec - Apr' }
            ],
            icon: '🍑'
          },
          {
            name: 'Apricots',
            varieties: ['Bergeron', 'Orangered', 'Rouge du Roussillon'],
            season: 'May - Aug',
            origins: [
              { country: 'France', period: 'Jun - Aug' },
              { country: 'Spain', period: 'May - Jul' },
              { country: 'Italy', period: 'Jun - Jul' }
            ],
            icon: '🍑'
          },
          {
            name: 'Plums',
            varieties: ['Greengage', 'Mirabelle', 'Damson'],
            season: 'Jul - Sep',
            origins: [
              { country: 'France', period: 'Jul - Sep' },
              { country: 'Spain', period: 'Jul - Sep' }
            ],
            icon: '🍑'
          },
          {
            name: 'Cherries',
            varieties: ['Burlat', 'Summit', 'Sweetheart'],
            season: 'May - Jul',
            origins: [
              { country: 'France', period: 'May - Jul' },
              { country: 'Spain', period: 'Apr - Jun' },
              { country: 'Italy', period: 'May - Jul' }
            ],
            icon: '🍒'
          },
          {
            name: 'Strawberries',
            varieties: ['Gariguette', 'Ciflorette', 'Charlotte'],
            season: 'Year-round',
            origins: [
              { country: 'France', period: 'Apr - Oct' },
              { country: 'Spain', period: 'Jan - May' },
              { country: 'Morocco', period: 'Dec - Apr' }
            ],
            icon: '🍓'
          },
          {
            name: 'Raspberries & Berries',
            varieties: ['Raspberry', 'Blueberry', 'Blackberry', 'Redcurrant'],
            season: 'May - Oct',
            origins: [
              { country: 'France', period: 'Jun - Sep' },
              { country: 'Spain', period: 'May - Jul' },
              { country: 'Portugal', period: 'Apr - Oct' }
            ],
            icon: '🫐'
          },
          {
            name: 'Melons',
            varieties: ['Charentais', 'Cantaloupe', 'Galia', 'Piel de Sapo'],
            season: 'Year-round',
            origins: [
              { country: 'France', period: 'Jun - Sep' },
              { country: 'Spain', period: 'May - Oct' },
              { country: 'Morocco', period: 'Apr - Jun' },
              { country: 'Senegal', period: 'Nov - May' },
              { country: 'Brazil', period: 'Oct - Mar' }
            ],
            icon: '🍈'
          },
          {
            name: 'Watermelons',
            varieties: ['Sugar Baby', 'Crimson Sweet', 'Seedless'],
            season: 'Year-round',
            origins: [
              { country: 'Spain', period: 'May - Sep' },
              { country: 'Morocco', period: 'Apr - Jul' },
              { country: 'Senegal', period: 'Dec - Apr' },
              { country: 'Brazil', period: 'Oct - Mar' }
            ],
            icon: '🍉'
          },
          {
            name: 'Coconuts',
            varieties: ['Fresh coconut', 'Dry coconut', 'Coconut water'],
            season: 'Year-round',
            origins: [
              { country: 'Côte d\'Ivoire', period: 'Year-round' },
              { country: 'Sri Lanka', period: 'Year-round' },
              { country: 'Thailand', period: 'Year-round' },
              { country: 'Vietnam', period: 'Year-round' },
              { country: 'India', period: 'Year-round' }
            ],
            icon: '🥥'
          }
        ]
      },
      {
        name: 'Vegetables',
        families: [
          {
            name: 'Tomatoes',
            varieties: ['Round', 'Vine', 'Cherry', 'Beef heart', 'Roma'],
            season: 'Year-round',
            origins: [
              { country: 'Spain', period: 'Oct - Jun' },
              { country: 'Morocco', period: 'Nov - May' },
              { country: 'Netherlands', period: 'Apr - Nov' },
              { country: 'France', period: 'Jun - Oct' }
            ],
            icon: '🍅',
            ripened: true
          },
          {
            name: 'Bell peppers',
            varieties: ['Red', 'Yellow', 'Green', 'Orange'],
            season: 'Year-round',
            origins: [
              { country: 'Spain', period: 'Oct - Jun' },
              { country: 'Morocco', period: 'Nov - May' },
              { country: 'Netherlands', period: 'Apr - Nov' }
            ],
            icon: '🫑'
          },
          {
            name: 'Cucumbers',
            varieties: ['Long', 'Noa', 'Mini'],
            season: 'Year-round',
            origins: [
              { country: 'Spain', period: 'Sep - Jun' },
              { country: 'Netherlands', period: 'Apr - Oct' }
            ],
            icon: '🥒'
          },
          {
            name: 'Zucchini',
            varieties: ['Green', 'Yellow', 'Round'],
            season: 'Year-round',
            origins: [
              { country: 'Spain', period: 'Sep - Jun' },
              { country: 'Morocco', period: 'Oct - Apr' },
              { country: 'France', period: 'May - Oct' }
            ],
            icon: '🥒'
          },
          {
            name: 'Eggplants',
            varieties: ['Long', 'Round', 'Graffiti'],
            season: 'Year-round',
            origins: [
              { country: 'Spain', period: 'Sep - Jun' },
              { country: 'Netherlands', period: 'Apr - Oct' }
            ],
            icon: '🍆'
          },
          {
            name: 'Onions',
            varieties: ['Yellow', 'Red', 'White', 'Shallot'],
            season: 'Year-round',
            origins: [
              { country: 'France', period: 'Aug - Apr' },
              { country: 'Netherlands', period: 'Jul - Apr' },
              { country: 'Spain', period: 'Apr - Sep' },
              { country: 'Senegal', period: 'Dec - Apr' },
              { country: 'Niger', period: 'Nov - Mar' },
              { country: 'Burkina Faso', period: 'Nov - Mar' },
              { country: 'India', period: 'Year-round' },
              { country: 'Pakistan', period: 'Nov - Apr' }
            ],
            icon: '🧅'
          },
          {
            name: 'Garlic',
            varieties: ['White', 'Pink', 'Purple'],
            season: 'Year-round',
            origins: [
              { country: 'France', period: 'Jul - Mar' },
              { country: 'Spain', period: 'Jun - Mar' },
              { country: 'Argentina', period: 'Feb - Jul' }
            ],
            icon: '🧄'
          },
          {
            name: 'Potatoes',
            varieties: ['Charlotte', 'Bintje', 'Ratte', 'Baby', 'Agata'],
            season: 'Year-round',
            origins: [
              { country: 'France', period: 'Jun - Mar' },
              { country: 'Netherlands', period: 'Jul - Apr' },
              { country: 'Germany', period: 'Aug - May' },
              { country: 'Niger', period: 'Nov - Feb' },
              { country: 'Burkina Faso', period: 'Nov - Feb' }
            ],
            icon: '🥔'
          },
          {
            name: 'Carrots',
            varieties: ['Nantes', 'Bunch', 'Mini', 'Rainbow'],
            season: 'Year-round',
            origins: [
              { country: 'France', period: 'Jun - Apr' },
              { country: 'Netherlands', period: 'Jul - May' },
              { country: 'Spain', period: 'Nov - May' }
            ],
            icon: '🥕'
          },
          {
            name: 'Leeks',
            varieties: ['Large', 'Mini'],
            season: 'Sep - Apr',
            origins: [
              { country: 'France', period: 'Sep - Apr' },
              { country: 'Belgium', period: 'Oct - Mar' }
            ],
            icon: '🥬'
          },
          {
            name: 'Cabbages',
            varieties: ['White', 'Red', 'Green', 'Cauliflower', 'Broccoli', 'Romanesco', 'Brussels sprouts'],
            season: 'Year-round',
            origins: [
              { country: 'France', period: 'Aug - Apr' },
              { country: 'Spain', period: 'Oct - May' },
              { country: 'Netherlands', period: 'Jun - Nov' }
            ],
            icon: '🥦'
          },
          {
            name: 'Lettuces',
            varieties: ['Butterhead', 'Batavia', 'Oak leaf', 'Iceberg', 'Romaine', 'Lamb\'s lettuce', 'Arugula'],
            season: 'Year-round',
            origins: [
              { country: 'France', period: 'Apr - Nov' },
              { country: 'Spain', period: 'Oct - May' }
            ],
            icon: '🥬'
          },
          {
            name: 'Spinach',
            varieties: ['Leaf', 'Baby'],
            season: 'Year-round',
            origins: [
              { country: 'France', period: 'Mar - Nov' },
              { country: 'Spain', period: 'Oct - Apr' }
            ],
            icon: '🥬'
          },
          {
            name: 'Green beans',
            varieties: ['Extra-fine', 'Fine', 'Flat'],
            season: 'Year-round',
            origins: [
              { country: 'Kenya', period: 'Year-round' },
              { country: 'Morocco', period: 'Oct - May' },
              { country: 'Senegal', period: 'Nov - Apr' }
            ],
            icon: '🫛'
          },
          {
            name: 'Peas',
            varieties: ['Fresh', 'Snow peas'],
            season: 'Mar - Jul',
            origins: [
              { country: 'France', period: 'May - Jul' },
              { country: 'Spain', period: 'Mar - Jun' }
            ],
            icon: '🫛'
          },
          {
            name: 'Asparagus',
            varieties: ['White', 'Green', 'Purple'],
            season: 'Year-round',
            origins: [
              { country: 'France', period: 'Apr - Jun' },
              { country: 'Spain', period: 'Feb - May' },
              { country: 'Peru', period: 'Sep - Dec' }
            ],
            icon: '🥬'
          },
          {
            name: 'Artichokes',
            varieties: ['Globe', 'Purple', 'Baby'],
            season: 'Mar - Nov',
            origins: [
              { country: 'France', period: 'May - Nov' },
              { country: 'Spain', period: 'Mar - Jun' },
              { country: 'Italy', period: 'Mar - May' }
            ],
            icon: '🥬'
          },
          {
            name: 'Mushrooms',
            varieties: ['Button', 'Shiitake', 'Oyster', 'Portobello'],
            season: 'Year-round',
            origins: [
              { country: 'France', period: 'Year-round' },
              { country: 'Netherlands', period: 'Year-round' },
              { country: 'Poland', period: 'Year-round' }
            ],
            icon: '🍄'
          },
          {
            name: 'Fresh herbs',
            varieties: ['Parsley', 'Cilantro', 'Basil', 'Mint', 'Chives', 'Thyme', 'Rosemary'],
            season: 'Year-round',
            origins: [
              { country: 'France', period: 'May - Oct' },
              { country: 'Morocco', period: 'Year-round' },
              { country: 'Israel', period: 'Year-round' },
              { country: 'Thailand', period: 'Year-round' },
              { country: 'Vietnam', period: 'Year-round' }
            ],
            icon: '🌿'
          },
          {
            name: 'Ginger & Turmeric',
            varieties: ['Fresh ginger', 'Fresh turmeric'],
            season: 'Year-round',
            origins: [
              { country: 'Peru', period: 'Year-round' },
              { country: 'China', period: 'Year-round' },
              { country: 'Brazil', period: 'Year-round' },
              { country: 'India', period: 'Year-round' },
              { country: 'Thailand', period: 'Year-round' },
              { country: 'Vietnam', period: 'Year-round' }
            ],
            icon: '🫚'
          },
          {
            name: 'Chili peppers',
            varieties: ['Jalapeño', 'Habanero', 'Bird\'s eye', 'Sweet'],
            season: 'Year-round',
            origins: [
              { country: 'Spain', period: 'Apr - Nov' },
              { country: 'Morocco', period: 'Sep - May' },
              { country: 'Netherlands', period: 'Apr - Oct' }
            ],
            icon: '🌶️'
          }
        ]
      }
    ]
  }
};

// Impact & engagements
export const impact = {
  fr: {
    title: 'Impact & Engagements',
    subtitle: 'Des faits, pas des promesses',
    stats: [
      { value: '50+', label: 'Emplois créés à Abidjan' },
      { value: '20+', label: 'Producteurs partenaires dans le monde' },
      { value: '2014', label: 'Année de création' },
      { value: '365j', label: 'Approvisionnement continu' }
    ],
    commitments: [
      {
        title: 'Emploi local',
        description: 'Création d\'emplois qualifiés à Abidjan (logistique du froid, qualité, commerce) et dans nos hubs de sourcing.'
      },
      {
        title: 'Réduction du gaspillage',
        description: 'La maîtrise de la chaîne du froid et de la mûrisserie permet de réduire significativement les pertes alimentaires.'
      },
      {
        title: 'Partenariats durables',
        description: 'Relations de long terme avec les producteurs européens et sud-africains, basées sur la confiance et la régularité.'
      }
    ]
  },
  en: {
    title: 'Impact & Commitments',
    subtitle: 'Facts, not promises',
    stats: [
      { value: '50+', label: 'Jobs created in Abidjan' },
      { value: '20+', label: 'Partner producers worldwide' },
      { value: '2014', label: 'Year founded' },
      { value: '365d', label: 'Continuous supply' }
    ],
    commitments: [
      {
        title: 'Local employment',
        description: 'Creating skilled jobs in Abidjan (cold logistics, quality, sales) and in our sourcing hubs.'
      },
      {
        title: 'Waste reduction',
        description: 'Mastering the cold chain and ripening significantly reduces food waste.'
      },
      {
        title: 'Sustainable partnerships',
        description: 'Long-term relationships with producers in Europe and South Africa, based on trust and reliability.'
      }
    ]
  }
};

// Company info
export const companyInfo = {
  fr: {
    name: 'Océana',
    tagline: 'Du producteur au rayon',
    description: 'Plateforme intégrée du producteur au rayon, pour l\'Afrique et le Moyen-Orient.',
    founded: 2014,
    headquarters: 'Abidjan, Côte d\'Ivoire',
    hubs: [
      { name: 'Hub Europe', location: 'Boulogne-sur-Gesse, France' },
      { name: 'Hub Afrique du Sud', location: 'Stellenbosch, Afrique du Sud' },
      { name: 'Hub Émirats', location: 'Ajman, Émirats Arabes Unis' }
    ]
  },
  en: {
    name: 'Océana',
    tagline: 'From producer to shelf',
    description: 'Integrated platform from producer to shelf, for Africa and the Middle East.',
    founded: 2014,
    headquarters: 'Abidjan, Côte d\'Ivoire',
    hubs: [
      { name: 'Europe Hub', location: 'Boulogne-sur-Gesse, France' },
      { name: 'South Africa Hub', location: 'Stellenbosch, South Africa' },
      { name: 'UAE Hub', location: 'Ajman, United Arab Emirates' }
    ]
  }
};

// Legacy exports for compatibility
export const images = {
  hero: 'https://images.unsplash.com/photo-1585939268339-886c9643ee98?crop=entropy&cs=srgb&fm=jpg&q=85',
  fruits1: 'https://images.unsplash.com/photo-1511688878353-3a2f5be94cd7?crop=entropy&cs=srgb&fm=jpg&q=85',
  fruits2: 'https://images.unsplash.com/photo-1519996529931-28324d5a630e?crop=entropy&cs=srgb&fm=jpg&q=85',
  vegetables1: 'https://images.pexels.com/photos/5719966/pexels-photo-5719966.jpeg',
  vegetables2: 'https://images.unsplash.com/photo-1686226421696-c2ccf97eb475?crop=entropy&cs=srgb&fm=jpg&q=85',
  market1: 'https://images.unsplash.com/photo-1643131514219-1e480cce39aa?crop=entropy&cs=srgb&fm=jpg&q=85',
  market2: 'https://images.unsplash.com/photo-1760539446586-d8b94be8d46d?crop=entropy&cs=srgb&fm=jpg&q=85',
  basket: 'https://images.unsplash.com/photo-1553518137-d567777430b5?crop=entropy&cs=srgb&fm=jpg&q=85',
  quality: 'https://images.unsplash.com/photo-1664568218050-8068915c3b40?crop=entropy&cs=srgb&fm=jpg&q=85',
  boutique: 'https://images.unsplash.com/photo-1467453678174-768ec283a940?crop=entropy&cs=srgb&fm=jpg&q=85',
  coldStorage: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?crop=entropy&cs=srgb&fm=jpg&q=85',
  truck: 'https://images.unsplash.com/photo-1657288649124-b80bdee3c17e?crop=entropy&cs=srgb&fm=jpg&q=85'
};

export const testimonials = [
  {
    id: 1,
    name: 'Carrefour Côte d\'Ivoire',
    role: 'Grande distribution',
    content: {
      fr: 'Océana nous garantit une régularité d\'approvisionnement et une qualité constante. Leur maîtrise de la chaîne du froid fait la différence.',
      en: 'Océana guarantees us supply regularity and consistent quality. Their mastery of the cold chain makes the difference.'
    }
  },
  {
    id: 2,
    name: 'Sofitel Abidjan',
    role: 'Hôtellerie premium',
    content: {
      fr: 'Les fruits mûris à point d\'Océana sont parfaits pour notre buffet petit-déjeuner. Livraison fiable, produits impeccables.',
      en: 'Océana\'s perfectly ripened fruits are perfect for our breakfast buffet. Reliable delivery, impeccable products.'
    }
  },
  {
    id: 3,
    name: 'Producteur Lot-et-Garonne',
    role: 'Partenaire producteur',
    content: {
      fr: 'Avec Océana, nous avons trouvé un débouché fiable pour nos pommes. Ils comprennent notre métier et respectent notre travail.',
      en: 'With Océana, we found a reliable outlet for our apples. They understand our business and respect our work.'
    }
  }
];

// Product categories for legacy support
export const productCategories = [
  {
    id: 1,
    name: 'Fruits Tropicaux',
    description: 'Bananes mûries, mangues, papayes, ananas',
    image: images.fruits1
  },
  {
    id: 2,
    name: 'Agrumes',
    description: 'Oranges, citrons, clémentines, pamplemousses',
    image: images.fruits2
  },
  {
    id: 3,
    name: 'Pommes & Poires',
    description: 'Golden, Gala, Royal Gala, Granny Smith, Conférence',
    image: images.vegetables1
  },
  {
    id: 4,
    name: 'Légumes',
    description: 'Tomates, poivrons, carottes, oignons, pommes de terre',
    image: images.vegetables2
  }
];

export const services = [];
